interface OrnamentProps {
  width?: number;
  className?: string;
}

export function Ornament({ width = 200, className = '' }: OrnamentProps) {
  return (
    <svg
      className={`opacity-55 ${className}`}
      width={width}
      height="14"
      viewBox="0 0 200 14"
      aria-hidden="true"
      fill="none"
      stroke="currentColor"
      strokeWidth="1"
    >
      <line x1="0" y1="7" x2="73" y2="7" />
      <circle cx="83" cy="7" r="2" fill="currentColor" />
      <path d="M93 7 L100 2 L107 7 L100 12 Z" fill="currentColor" stroke="none" />
      <circle cx="117" cy="7" r="2" fill="currentColor" />
      <line x1="127" y1="7" x2="200" y2="7" />
    </svg>
  );
}
